export function userRegistered() {
  const temp: any = window;
  temp.dataLayer.push({ event: 'lead' });
}
